
import axios from 'axios';
import { getHostname } from './server/server'

const hostname = getHostname();
const path = '/v2/hubspot';

async function getTicketPipelines() {
    const res = await axios.get(`${hostname}${path}/ticket-pipelines`);
    const pipelines = res.data?.pipelines; 
    return pipelines
}

async function getTicketStages() {
    const res = await axios.get(`${hostname}${path}/ticket-stages`);
    const stages = res.data?.stages;
    return stages;
}

async function getTicketLabels() {
    const res = await axios.get(`${hostname}${path}/ticket-labels`);
    const labels = res.data?.labels;
    return labels;
}

async function createTicket({ title, description, pipelineId, stageId, labelId, priority, assosiateCustomerId, assosiateContactEmail }) {
    const res = await axios.post(`${hostname}${path}/ticket`, {
        title,
        description,
        pipelineId,
        stageId,
        labelId,
        priority,
        assosiateCustomerId,
        assosiateContactEmail
    });
    return res.data;
}

export {
    getTicketPipelines,
    getTicketStages,
    getTicketLabels,
    createTicket
}